module.exports = __webpack_public_path__ + "static/media/pattern1@2x.fe7a3464.png";